<template>
  <footer class="app-footer">
    <span class="txt_arial">Copyright © 1998-{{ newYear }} DRCnet. All Rights Reserved</span> 版权所有 国研网
  </footer>
</template>

<script>
  export default {
    name: "AppFooter",
    data() {
    return {
      newYear: new Date().getFullYear(),
    };
  },
  }
</script>

<style lang="scss" scoped>
  .app-footer{
    height: 38px;
    line-height: 18px;
    background-color: #ececec;
    z-index: 2000;
    text-align: center;
    color: #777;
    font-size: 12px;
    padding: 10px;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0
  }

</style>
